import { JobsitesContainer } from './JobsitesContainer';

const name = 'JobsitesContainer';

export { JobsitesContainer, name };
